import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Skeleton from 'react-loading-skeleton';
import sessionEngagementActivityAnalyticService from '../../../services/session-engagement-activity-analytics.service';

const SessionHeatMap = () => {
  const [heatMapData, setHeatMapData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getUserMetrics = async () => {
      setError(false);
      setLoading(true);
      try {
        const data =
          await sessionEngagementActivityAnalyticService.getSessionHeatMapDetails();
        const transformedData = data?.session_heatmap.map((dayEntry) => ({
          name: dayEntry.day,
          data: dayEntry.hourly_sessions.map((hour) => hour.count),
        }));
        setHeatMapData(transformedData);
      } catch (err) {
        console.error('Error fetching session heatmap details', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    getUserMetrics();
  }, []);

  if (loading) {
    return (
      <div className="mb-3">
        <Skeleton
          height={20}
          width={220}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
        />
        <Skeleton
          height={14}
          width={160}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
          style={{ marginTop: 8 }}
        />
        <Skeleton height={280} baseColor="#dee2e6" highlightColor="#e9ecef" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-danger text-center fw-semibold">
        Failed to load user registration metrics details.
      </div>
    );
  }

  const heatmapOptions = {
    chart: {
      type: 'heatmap',
      height: 350,
      toolbar: { show: false },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ['#008FFB'],
    xaxis: {
      type: 'category',
      categories: Array.from({ length: 24 }, (_, i) => `${i}:00`),
      labels: {
        style: { colors: '#6b7280', fontSize: '10px' },
        rotate: -45,
      },
    },
    yaxis: {
      labels: {
        style: { colors: '#6b7280' },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} sessions`,
      },
    },
    plotOptions: {
      heatmap: {
        shadeIntensity: 0.5,
        radius: 0,
        useFillColorAsStroke: false,
        colorScale: {
          ranges: [
            { from: 0, to: 0, name: 'None', color: '#f5f5f5' }, // lightest gray
            { from: 1, to: 10, name: 'Very Low', color: '#c6e48b' }, // light green
            { from: 11, to: 30, name: 'Low', color: '#7bc96f' }, // green
            { from: 31, to: 60, name: 'Medium', color: '#239a3b' }, // dark green
            { from: 61, to: Infinity, name: 'High', color: '#196127' }, // darkest green
          ],
        },
      },
    },
  };

  const heatmapSeries = heatMapData;

  return (
    <div className="mt-3">
      <Chart
        options={heatmapOptions}
        series={heatmapSeries}
        type="heatmap"
        height={350}
      />
    </div>
  );
};

export default SessionHeatMap;
